<template>
  <div class="content">
    <div class="bodycontent">
      <el-form :model="formData" ref="formData" label-width="160px" :rules="rules">
        <el-form-item label="退货地址名称" prop="title">
          <el-input v-model="formData.title" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="name">
          <el-input v-model="formData.name" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="手机" prop="mobile">
          <el-input v-model="formData.mobile" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="formData.tel" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="邮编">
          <el-input v-model="formData.code" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="地区">
          <el-cascader
            :options="options"
            v-model="area_id"
            expand-trigger="hover"
            style="width:260px"
            @change="handleChangeArea"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input type="textarea" v-model="formData.address" class="input_box" rows="3"></el-input>
        </el-form-item>
        <el-form-item label="是否显示">
          <el-radio-group v-model="formData.is_show">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="bottom_btn">
        <el-button type="primary" @click="submit()" :loading="loading">提交</el-button>
        <el-button @click="goback()">返回列表</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { areajson } from "@/components/public/area";
import { AddBackAddress, EditBackAddress, BackAddressDetail } from "@/api/backAddress";
export default {
  components:{
  },
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  mounted() {
    this.init();
  },
  data() {
    return{
      aid: "", //编辑时当前id
      formData:{},
      area_id: [], //地址
      options: areajson, //外部json数据
      if_add: true, //判断是新增/修改
      loading: false,
      rules: {
        title: [
          { required: true, message: "请输入退货地址名称", trigger: "blur" }
        ],
        name: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" }
        ],
        mobile: [
          { required: true, message: "请输入联系人手机号", trigger: "blur" }
        ],
        address: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" }
        ],
      }
    }
  },
  methods: {
    init(){
      if(this.$route.query.aid){
        this.if_add =false;
        this.aid = this.$route.query.aid;
        var data = {
          token: this.token,
          app_id: this.app_id,
          id: this.aid
        }
        BackAddressDetail(data).then(res=>{
          if(res.code == 200){
            var r = Object.assign({},res.data)
            this.formData = {
              id: r.id,
              title: r.title,
              name: r.name,
              mobile: r.mobile,
              tel: r.tel,
              code: r.code,
              area_id: r.area_id,
              address: r.address,
              is_show: r.is_show
            }
            var area = (this.formData.area_id).toString();
            var area0 = area.split('')[0]+area.split('')[1]+'0000'
            var area1 = area.split('')[0]+area.split('')[1]+area.split('')[2]+area.split('')[3]+'00'
            this.area_id = [area0,area1,area]
            console.log(this.area_id)
          }
        })
      }else{
        this.formData = {
          name: "",
          mobile: "",
          address: "",
          is_show: 1
        }
      }
    },
    submit(){
      console.log(this.area_id)
      if(this.area_id.length == 0){
        this.$message({
          type:"error",
          message:"请选择地区!"
        })
      }else{
        this.$refs['formData'].validate((valid)=>{
          if(valid){
            this.loading = true;
            var data = Object.assign({},this.formData)
            data.token = this.token;
            data.app_id = this.app_id;
            data.area_id = this.area_id[2];
            console.log(data)
            if(this.if_add){
              AddBackAddress(data).then(res=>{
                if(res.code == 200){
                  this.$message({
                    type:"success",
                    message:"保存成功",
                  })
                  this.goback();
                }else{
                  this.$message({
                    type:"error",
                    message: res.msg
                  })
                }
                this.loading = false;
              })
            }else{
              EditBackAddress(data).then(res=>{
                if(res.code == 200){
                  this.$message({
                    type:"success",
                    message:"保存成功",
                  })
                  this.goback();
                }else{
                  this.$message({
                    type:"error",
                    message: res.msg
                  })
                }
                this.loading = false;
              })
            }
          }else{
            console.log('error submit!!');
            return false;
          }
        })
      }
    },
    goback(){
      this.$router.go(-1);
    },
    handleChangeArea(val){
      console.log(val);
    },
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 10px 55px 30px 0;
  height: calc(100vh - 102px);
  font-size: 14px;
  .bodycontent{
    padding: 27px 0;
    height: 96%;
    overflow: auto;
    border: 1px solid #f1f1f1;
    box-shadow: 0 0 3px #f1f1f1;
    .input_box{
      width: 400px;
    }
    .bottom_btn {
      margin-left: 160px;
      margin-top: 30px;
    }
  }
}
</style>
